// src/pages/AddLocation.jsx
import React from "react";
import { supabase } from "../lib/supabaseClient";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LocationForm from "../components/LocationForm";

export default function AddLocation() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleSubmit = async (formData) => {
    const { data: { user }, error: authError } = await supabase.auth.getUser();

    if (authError || !user) {
      console.error(t("location.error.auth", { error: authError?.message || "" }));
      return;
    }

    const { error } = await supabase
      .from("locations")
      .insert([{ ...formData, client_id: user.id }]);

    if (error) {
      console.error(t("location.error.create", { error: error.message }));
    } else {
      navigate("/location");
    }
  };

  return (
    <div className="max-w-2xl mx-auto px-6 py-10">
      <h1 className="font-serif text-2xl mb-6" style={{ color: "#1a1a1a" }}>
        {t("location.add.title")}
      </h1>
      <LocationForm onSubmit={handleSubmit} onCancel={() => navigate("/location")} />
    </div>
  );
}
